<template>
    <div>
        <div
            class="regel borderbottom lineheight32 floatleft  paddingleft10 paddingtop5 paddingbottom5 hutnr"
        >
            <div class="label width20 floatleft bold uppercase ">
                Hut {{ index + 1 }}:
            </div>
            <div class="options aantal_pers">
                <div
                    class="hutstyle variabel widthauto firstselect marginright20 floatleft"
                >
                    <div class="select-drop floatleft">
                        <select
                            style="width: 45px;"
                            v-model="volwCount"
                            class="selectpaddingsmall marginright5 floatleft"
                        >
                            <option value="0">0</option>
                            <option
                                v-for="index in maxPax - kindCount"
                                :key="'volwCount' + index"
                                :value="index"
                            >
                                {{ index }}
                            </option>
                        </select>
                    </div>
                    <div class="floatleft">Volwassenen</div>
                </div>

                <div class="widthauto marginright20 height32 floatleft">
                    <div class="select-drop floatleft">
                        <select
                            style="width: 45px;"
                            v-model="kindCount"
                            class="selectpaddingsmall marginright5 floatleft"
                        >
                            <option value="0">0</option>
                            <option
                                v-for="index in maxPax - volwCount"
                                :key="'kindCount' + index"
                                :value="index"
                            >
                                {{ index }}
                            </option>
                        </select>
                    </div>
                    <div class="floatleft">Kinderen</div>
                </div>
            </div>
        </div>

        <div
            v-for="kindIndex in kindCount"
            :key="'kindIndexLeeftijd' + kindIndex"
            class="regel borderbottom regelpadding lineheight32 floatleft"
        >
            <div class="label width20 floatleft bold uppercase">
                &nbsp;&nbsp;Leeftijd Kind {{ kindIndex }}:
            </div>
            <div class="options aantal_pers">
                <div>
                    <CabinSetupItemSelect
                        :cabinIndex="index"
                        :childIndex="kindIndex"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CabinSetupItemSelect from './CabinSetupItemSelect'

export default {
    name: 'CabinSetupItem',
    props: {
        index: Number,
    },
    components: {
        CabinSetupItemSelect,
    },
    computed: {
        volwCount: {
            get: function() {
                return this.cabinSetup.volwassenen
            },
            set: function(newVal) {
                this.$store.commit('changeCabinSetup', {
                    cabinSetupIndex: this.index,
                    volwCount: newVal,
                })
            },
        },

        kindCount: {
            get: function() {
                return this.cabinSetup.kindCount
            },
            set: function(newVal) {
                this.$store.commit('changeCabinSetup', {
                    cabinSetupIndex: this.index,
                    kindCount: newVal,
                })
            },
        },

        cabinSetup: function() {
            return this.$store.state.cabinSetup[this.index]
        },

        maxPax: function() {
            return this.$store.state.cabinMaxPax
        },
    },
}
</script>

<style scoped></style>
